import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ButtonItem } from "./button-item.model";

@Component({
  selector: "app-tab-panel-button-group",
  templateUrl: "./tab-panel-button-group.component.html",
  styleUrls: ["./tab-panel-button-group.component.css"]
})
export class TabPanelButtonGroupComponent {
  @Input() items: ButtonItem[];
  @Input() selectedItemKeys = 0;
  @Input() stylingMode = "outlined";

  @Output() itemClicked = new EventEmitter<number>();

  constructor() { }
}
